import {
  createFileRoute,
  Outlet,
  redirect,
  useMatches,
} from "@tanstack/react-router";
import { DashboardHeader } from "@/components/dashboard";
import { WSProvider } from "@/hooks/use-websocket";
import { ModalProvider } from "@/lib/modal";
import { sessionQueryOptions } from "@/lib/auth";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: async ({ context: { queryClient } }) => {
    const session = await queryClient.ensureQueryData(sessionQueryOptions);

    if (!session?.data?.user) throw redirect({ to: "/" });

    return { session: session.data };
  },

  component: DashboardLayout,
});

function DashboardLayout() {
  const matches = useMatches();
  const isGuildPage = matches.some((match) =>
    match.routeId.includes("/dashboard/guilds/$applicationGuildId")
  );
  const isAdminPage = matches.some((match) =>
    match.routeId.includes("/dashboard/admin")
  );

  return (
    <WSProvider>
      <ModalProvider>
        <div className="noise bg-background min-h-dvh">
          <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
            <div className="absolute left-1/4 top-0 h-[500px] w-[700px] rounded-full bg-rose-500/[0.04] blur-[100px]" />
            <div className="absolute right-0 top-1/3 h-[300px] w-[300px] rounded-full bg-red-500/[0.03] blur-[80px]" />
          </div>
          <div className="bg-grid pointer-events-none fixed inset-0 -z-10 opacity-[0.15]" />
          {!(isGuildPage || isAdminPage) && (
            <>
              <DashboardHeader />
              <main className="mx-auto max-w-6xl px-6 py-8">
                <Outlet />
              </main>
            </>
          )}
          {(isGuildPage || isAdminPage) && <Outlet />}
        </div>
      </ModalProvider>
    </WSProvider>
  );
}
